var _defs, _circle, _path, _path2, _path3, _path4, _polygon, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _polygon2, _path13, _path14, _path15, _path16, _ellipse, _path17, _path18, _path19, _rect, _rect2, _circle2, _circle3, _circle4, _path20, _path21, _path22, _path23, _path24, _rect3, _ellipse2, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _circle5, _circle6, _line, _circle7, _rect4, _rect5, _ellipse3, _rect6, _ellipse4, _rect7, _rect8, _path36, _path37, _path38;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg403Error(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_17",
    "data-name": "Layer 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 507.11 596.36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#e3f0ff;}.cls-11,.cls-2,.cls-26{fill:#ffe28e;}.cls-3{fill:url(#linear-gradient);}.cls-4{fill:url(#linear-gradient-2);}.cls-5{fill:url(#linear-gradient-3);}.cls-6{fill:url(#linear-gradient-4);}.cls-30,.cls-7{fill:#00479b;}.cls-8{fill:url(#linear-gradient-5);}.cls-9{fill:url(#linear-gradient-6);}.cls-10{fill:#4296cf;stroke:#4296cf;}.cls-10,.cls-11,.cls-12,.cls-14,.cls-15,.cls-16,.cls-17,.cls-18,.cls-19,.cls-20,.cls-26,.cls-28,.cls-29,.cls-30,.cls-31,.cls-33{stroke-miterlimit:10;}.cls-11{stroke:#ffe28e;}.cls-12{fill:#d1d4d4;}.cls-12,.cls-16{stroke:#d1d4d4;}.cls-13{fill:#ffeab9;}.cls-14,.cls-15,.cls-31{stroke-width:7px;}.cls-14{fill:url(#linear-gradient-7);stroke:url(#linear-gradient-8);}.cls-15{fill:url(#linear-gradient-9);stroke:url(#linear-gradient-10);}.cls-16{fill:#fff;}.cls-17{fill:#006aea;stroke:#006aea;}.cls-18,.cls-19,.cls-20{stroke:#fff;}.cls-18{fill:url(#linear-gradient-11);}.cls-19{fill:url(#linear-gradient-12);}.cls-20{fill:url(#linear-gradient-13);}.cls-21{fill:url(#linear-gradient-14);}.cls-22{fill:url(#linear-gradient-15);}.cls-23{fill:url(#linear-gradient-16);}.cls-24{fill:url(#linear-gradient-17);}.cls-25{fill:#4d4d4d;}.cls-26{stroke:#ffeab9;}.cls-27{fill:url(#radial-gradient);}.cls-28{fill:#deb87d;stroke:#deb87d;}.cls-29,.cls-33{fill:none;}.cls-29,.cls-30{stroke:#00479b;}.cls-30{stroke-width:26px;}.cls-31{fill:url(#linear-gradient-18);stroke:url(#linear-gradient-19);}.cls-32{fill:#f2f2f2;}.cls-33{stroke:#ebf6fc;stroke-width:5px;}.cls-34{fill:#e08561;}.cls-35{fill:#f29e75;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 866.25,
    y1: 328.66,
    x2: 928.57,
    y2: 328.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9cc8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#7fb6fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#569ef5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#4b97f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2781ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1073ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006aea"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 933.12,
    y1: 328.65,
    x2: 861.18,
    y2: 328.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#9cc8ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#75b1fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#1476ed"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006aea"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 203.52,
    y1: 254.1,
    x2: 270.47,
    y2: 254.1,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 831.81,
    y1: 328.97,
    x2: 749.23,
    y2: 335.17,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 684.95,
    y1: 339.43,
    x2: 732.24,
    y2: 339.43,
    gradientTransform: "matrix(-0.94, 0, 0, 1.01, 1510.99, -5.19)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 890.22,
    y1: 329.23,
    x2: 804.57,
    y2: 329.42,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 845.5,
    y1: 351.04,
    x2: 896.64,
    y2: 351.04,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 842,
    y1: 351.04,
    x2: 900.14,
    y2: 351.04,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 798.97,
    y1: 352.79,
    x2: 850.89,
    y2: 352.79,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 795.47,
    y1: 352.79,
    x2: 854.39,
    y2: 352.79,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 713.45,
    y1: 304.7,
    x2: 715.99,
    y2: 304.7,
    gradientTransform: "matrix(-1, 0, 0, 1, 1004.28, -77.98)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 713.45,
    y1: 328.66,
    x2: 715.99,
    y2: 328.66,
    gradientTransform: "matrix(-1, 0, 0, 1, 1004.28, -77.98)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 713.45,
    y1: 315.8,
    x2: 715.99,
    y2: 315.8,
    gradientTransform: "matrix(-1, 0, 0, 1, 1004.28, -77.98)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 907.23,
    y1: 342.63,
    x2: 945.33,
    y2: 342.63,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 954.32,
    y1: 339.19,
    x2: 898.18,
    y2: 347.72,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 739.3,
    y1: 412.64,
    x2: 780.65,
    y2: 412.64,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 726.81,
    y1: 419.1,
    x2: 791.04,
    y2: 403.89,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: 1051.69,
    cy: 245.81,
    fx: 1065.164658484726,
    fy: 259.42706109112646,
    r: 19.16,
    gradientTransform: "matrix(-0.82, 0.01, 0.01, 0.86, 1709.7, 57.23)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffffdc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8c79e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 110.74,
    y1: 106.96,
    x2: 231.42,
    y2: 106.96,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 107.24,
    y1: 106.96,
    x2: 234.92,
    y2: 106.96,
    xlinkHref: "#linear-gradient-2"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 252.96,
    cy: 177.22,
    r: 171.81
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M922.58,373l9-4.27c-1.28-2.42-3.31-6.35-5.66-11.32-3.28-6.95-3.59-8.31-6.12-13.22-.86-1.67-.74-1.34-7.26-12.57-4.09-7.06-4.92-8.54-6.94-11.9-2.25-3.73-4.16-6.78-5.48-8.86l-17.29,11c1.06,1.62,2.66,4.09,4.6,7.11,5.3,8.22,5.86,9.23,7.62,11.77a133.64,133.64,0,0,0,8.82,11.42c4.52,5.2,6,6,11.14,11.74C918.45,367.69,921,370.92,922.58,373Z",
    transform: "translate(-553.52 -77.98)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M922.58,373c2.18-1.2,6.63-3.5,8.84-4.63l-.18.55-3.77-7.34c-2.24-5-4.06-10.23-6.56-15.14S911.31,330,908.45,325c-2.77-4.74-5.75-9.35-8.68-14l.61.14q-8.57,5.63-17.25,11.09l.15-.71c5.24,8,11.93,19.7,17.87,27.05a122.44,122.44,0,0,0,10.88,12q5.58,5.89,10.55,12.33Zm0,0A143.79,143.79,0,0,0,912,360.66a149.74,149.74,0,0,1-11.09-11.85,134,134,0,0,1-9.52-13.14l-9-13.54-.29-.43Q891,316,899.9,310.44l.39-.25.23.38c5.89,9.52,13,22.35,18.57,32.12,2,3.61,3.56,7.44,5.24,11.2,1.09,2.52,2.85,4.73,4,7.2l3.6,7.4.19.4-.38.16c-2.28,1-6.88,3-9.19,3.9Z",
    transform: "translate(-553.52 -77.98)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M909.55,373.39l19-10.41L892,283.93l-25.72,8Z",
    transform: "translate(-553.52 -77.98)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M909.58,373.3l18.95-10.4,0,.11c-3.54-6.36-6.91-12.79-10.19-19.27s-6.51-13-9.65-19.53c-1.6-3.26-3.14-6.55-4.68-9.84s-3.12-6.55-4.6-9.87A134,134,0,0,1,891.89,284l.11,0-25.72,8,.05-.13a33,33,0,0,1,4.35,4.12,50.49,50.49,0,0,1,3.52,4.45c1.09,1.51,2,3.1,3,4.71s1.75,3.29,2.61,4.94c3.45,6.62,6.78,13.32,10.08,20.14s6.55,13.78,9.82,20.93S906.24,365.64,909.58,373.3Zm-.06.18c-3.88-5.91-7.8-12.2-11.76-18.61s-7.91-13.05-11.83-19.8-7.8-13.62-11.56-20.58c-.94-1.74-1.91-3.46-2.8-5.23s-1.72-3.6-2.44-5.47a55.85,55.85,0,0,1-1.89-5.74,30.84,30.84,0,0,1-1.06-6.06v-.11l.06,0,25.71-8,.07,0,0,.07a133.93,133.93,0,0,1,10.82,19c1.57,3.27,3,6.59,4.55,9.89s3,6.6,4.47,9.92q4.44,9.94,8.65,20c2.82,6.69,5.55,13.43,8.11,20.24l0,.08-.07,0Z",
    transform: "translate(-553.52 -77.98)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "224.04 304.72 203.52 295.73 249.96 203.48 270.47 212.47 224.04 304.72"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M777.59,382.79l-20.58-9-.08,0,0-.09c3.4-7.93,6.95-15.78,10.59-23.58s7.34-15.58,11.11-23.31c1.87-3.88,3.79-7.73,5.71-11.58s3.8-7.72,5.78-11.54,4-7.6,6.24-11.31,4.46-7.4,7-10.93l.05-.07.06,0,20.52,9,.05,0v.1a38.86,38.86,0,0,1-1.25,6.7,66.09,66.09,0,0,1-2.06,6.39c-.78,2.09-1.69,4.12-2.62,6.13s-2,4-3,5.91c-4,7.86-8.15,15.62-12.32,23.28s-8.39,15.21-12.63,22.52S781.78,376,777.59,382.79Zm-.06-.17c3.56-8.55,7.08-16.74,10.6-24.76s7-15.89,10.59-23.61,7.17-15.32,10.89-22.84c.93-1.88,1.84-3.77,2.82-5.62s2-3.65,3.19-5.4a62.8,62.8,0,0,1,3.73-5.15,39.61,39.61,0,0,1,4.57-4.83l0,.13-20.52-9,.12,0c-1.32,4.16-2.92,8.17-4.6,12.14s-3.48,7.88-5.37,11.75-3.89,7.68-5.83,11.52-3.9,7.67-5.9,11.48q-5.94,11.46-12.1,22.81c-4.1,7.58-8.29,15.1-12.63,22.55l0-.12Z",
    transform: "translate(-553.52 -77.98)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M834.89,373.55l28.45-.62Q856.16,398,849,423l-14.53-.3Z",
    transform: "translate(-553.52 -77.98)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M834.64,373.3l28.7-.72h.27l.08.46,9.3,56.86,3.16,19.34L801,445.85c5.83-15.65,14.35-39.39,22.1-52.53,4.48-8.22,8.56-14.66,11.52-20Zm.51.5a133.36,133.36,0,0,0,23.93,49.12l-24.14-24.87,14.53-.06-24.54,18.09L863,372.83l.35.45-28.2.52Z",
    transform: "translate(-553.52 -77.98)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M773.13,606.3l29,6.61,51-245.33-29-6.6q-12.07,70.41-28,145.34Q785.1,557.67,773.13,606.3Z",
    transform: "translate(-553.52 -77.98)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M773.42,606.12l28.72,6.59-.24.15c6.38-30.68,12.83-61.35,17-92.44,4.81-35.59,9.4-73.48,17.82-108.26a245.86,245.86,0,0,1,9.43-30,127.93,127.93,0,0,1,6.65-14.62l.25.4-14.46-3.41-14.48-3.33.25-.16c-1.07,6.07-5.73,33.25-6.71,38.59-1.79,8.11-.18,16.35,2.06,24.3s3.63,16.24,1.61,24.31c-9.21,46.31-21.44,92.15-38.53,136.24-2.07,5.22-4.18,10.43-6.44,15.58-.94,2.09-2,3.82-2.93,6.09Zm-.57.35c.09-5.22.55-10.85,1-16.12,3.13-36.46,8.62-72.81,14.88-108.78q2.71-15.37,5.64-30.71c1-4.47,1.78-11,3.5-15.22a42.31,42.31,0,0,1,3.64-7.24c4.4-7,10.53-13.52,13.48-21.34,1.76-4.38,2.55-10.67,3.48-15.28,1.9-10.27,3.79-20.54,5.52-30.84l0-.21.2,0c7.21,1.7,21.77,4.86,29,6.48l.22,0c.29,2.83.39,5.64.41,8.43A228.56,228.56,0,0,1,850.39,415c-7.88,45.86-23.71,91.57-34.76,136.74-4.88,20.31-9,40.77-13.34,61.21l0,.2-.2,0-29.2-6.63Z",
    transform: "translate(-553.52 -77.98)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M825.24,380.59l42.28,1.19,2.13-82.39c-2.4-.26-5.74-.56-9.75-.71-3.56-.13-6.32-.09-10.92,0-5,.07-6.32.18-8.32.21h-1.8c-1.56,0-4.7.33-11.55,1.74Z",
    transform: "translate(-553.52 -77.98)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M825.44,380.4c7,.24,14,.45,21,.63s14.06.33,21.08.49l-.26.25c.05-3.43.2-6.87,0-10.3a90.67,90.67,0,0,0-1-10.34,122,122,0,0,0-5.42-20.74c-2.35-6.93-5-13.87-7-20.79a126.45,126.45,0,0,1-4.38-20.73l17.94,20.57c-1.53.17-3,.31-4.55.44l-2.25.16c-.76.06-1.47,0-2.29.16-1.6.18-3.19.32-4.78.41-.8.05-1.59.09-2.39.11l-1.19,0c-.39,0-.78,0-1.24,0-.89,0-1.78.05-2.66,0s-1.78,0-2.67,0-1.73,0-2.7-.1l-1.61-.09h-.26l.24,0c.12,0,.14-.05.16-.07a3.46,3.46,0,0,0-1.13-.14c-.59,0-1.28,0-2,0-1.46,0-3.06.08-4.7.15l16.21-19.37c-1.16,5.45-2.57,11-4.18,16.75S840,329.67,838,336.11s-4.07,13.26-6.18,20.61q-1.59,5.5-3.17,11.4T825.44,380.4Zm-.41.39c-.9-2.41-1.8-5-2.67-7.73s-1.76-5.6-2.65-8.59c-1.77-6-3.52-12.48-5.14-19.38s-3.13-14.21-4.42-21.77S807.82,308,807,300.07l-1.36-13.2,17.57-6.16c1.83-.64,3.71-1.26,5.73-1.84,1-.3,2.08-.56,3.25-.83a36.24,36.24,0,0,1,4.15-.71c.46-.05.92-.1,1.48-.14l.9,0h.41l1.05-.1c.79-.08,1.74-.16,2.6-.21s1.77-.12,2.66-.16,1.76-.08,2.65-.09c3.79,0,7.79.23,11.66.59,1,.07,2,.26,3,.44l3.05.54c2,.39,4,.79,6,1.22l20.76,4.51-2.81,16.06a126.15,126.15,0,0,1-5.45,20.46c-2.4,6.81-5.37,13.6-8.07,20.4a121,121,0,0,0-6.49,20.45,87.92,87.92,0,0,0-1.54,10.26c-.33,3.43-.37,6.86-.49,10.29V382h-.25c-7.08-.23-14.13-.51-21.2-.69Z",
    transform: "translate(-553.52 -77.98)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M844.35,307.92",
    transform: "translate(-553.52 -77.98)"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "367.09 545.82 341.26 551.79 291.58 319.35 317.41 313.39 367.09 545.82"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M920.89,624l-26,6.11-.29.07-.11-.32C882.34,592,872.58,553.54,863.4,515c-7.57-33.85-16.78-67.56-18.54-102.37a148.47,148.47,0,0,1-.07-15.51L845,397c.12,0,25.84-6,26-6a65.53,65.53,0,0,1,10.39,13.65c8.18,13.68,12.12,29,14.95,44.5A1503.38,1503.38,0,0,1,920.89,624Zm-.56-.36c-18.93-57.62-36.54-115.3-50-173.83-3.48-14-5.8-28.12-3.67-42.66a69.78,69.78,0,0,1,3.89-15.69l.41.26-25.84,6,.26-.39a201.51,201.51,0,0,1,11.14,28c3.09,9.46,5.7,19,7.95,28.68Q877.26,512,886.88,570.69c3.17,19.61,6.09,39.24,8.23,59l-.41-.26,25.63-5.82Z",
    transform: "translate(-553.52 -77.98)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M879.16,352.57",
    transform: "translate(-553.52 -77.98)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M746.55,647.24c-3.33,9.81-5,14.72-2.54,16.73,5.83,4.78,30.4-6.44,41.47-24.2,2.73-4.38,7.52-12.06,3.85-17.68-3.87-5.9-15.63-7.26-23.67-4.4C755.32,621.37,751.78,631.81,746.55,647.24Z",
    transform: "translate(-553.52 -77.98)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M946.44,655.34c6.44,8.09,9.66,12.13,8,14.88-3.83,6.54-30.64,4.51-47-8.37-4-3.19-11.12-8.76-9.58-15.32,1.62-6.91,12.17-12.28,20.66-12.39C929.48,634,936.32,642.62,946.44,655.34Z",
    transform: "translate(-553.52 -77.98)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-13",
    cx: 392.44,
    cy: 214.29,
    rx: 10.14,
    ry: 10.55
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M861.07,427.4l29.6-1.15c4.2-.17,7-3.79,5.6-7.21a175.17,175.17,0,0,1-11.59-42c-4.41-30.88.51-58.76,4.7-82.93.49-2.8,1-5.34,1.39-7.51.53-2.72-1.41-5.34-4.49-6.09l-23.49-5.65c-3.45-.83-7,1-7.79,4a283.22,283.22,0,0,0-.32,144.31A6.18,6.18,0,0,0,861.07,427.4Z",
    transform: "translate(-553.52 -77.98)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M805.63,430.36l38.94-2.42c3.38-.21,5.95-2.7,5.8-5.62-.19-3.67-.36-8.23-.39-13.41-.14-20.56,1.93-28.65.24-44a134.7,134.7,0,0,0-3.77-19.43c-3.34-13.75-7.1-34.52-8.79-65.14-.18-3.27-3.65-5.65-7.38-5.06L812,278.2c-3.19.5-5.4,3-5.1,5.8,1.31,12,2.38,24.8,3.08,38.33,1.15,22.22,1.93,34.41.77,48.85a201.33,201.33,0,0,1-11.48,52.22C798,427,801.26,430.63,805.63,430.36Z",
    transform: "translate(-553.52 -77.98)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M830.42,357.63",
    transform: "translate(-553.52 -77.98)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 849.81,
    y: 274.43,
    width: 9.01,
    height: 23.19,
    transform: "translate(864.02 911.2) rotate(-147.21)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 829.93,
    y: 274.91,
    width: 9.01,
    height: 23.19,
    transform: "translate(-575.71 419.63) rotate(-32.79)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-18",
    cx: 289.56,
    cy: 226.72,
    r: 1.27
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-19",
    cx: 289.56,
    cy: 250.68,
    r: 1.27
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 289.56,
    cy: 237.82,
    r: 1.27
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M791.64,475.42",
    transform: "translate(-553.52 -77.98)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M934.29,305.94l11,3.64L928.9,379.32l-21.67-5.57Z",
    transform: "translate(-553.52 -77.98)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M934.25,305.86l11.11,3.64.07,0v.09c-.85,5.93-1.87,11.82-3,17.69s-2.3,11.73-3.57,17.56c-.61,2.93-1.28,5.84-2,8.75s-1.29,5.82-2,8.72a91.41,91.41,0,0,1-5.89,17l0,.09-.07,0-21.68-5.58h0l0-.11a21.12,21.12,0,0,1,0-5,34.71,34.71,0,0,1,.81-4.79,40.87,40.87,0,0,1,1.37-4.57c.54-1.49,1.17-2.93,1.76-4.39,2.39-5.83,4.9-11.58,7.46-17.23s5.18-11.18,7.82-16.51S931.6,310.68,934.25,305.86Zm.08.16c-1.86,6.48-3.74,12.58-5.6,18.57S925,336.32,923,342s-3.95,11.2-6.08,16.67c-.53,1.37-1,2.75-1.62,4.09a36.85,36.85,0,0,1-2,3.9,32.66,32.66,0,0,1-2.57,3.69,22.77,22.77,0,0,1-3.43,3.45l-.06-.12,21.67,5.57-.11.07a92.22,92.22,0,0,1,2.32-17.86c.64-2.91,1.39-5.8,2.08-8.71s1.41-5.8,2.17-8.69q2.19-8.69,4.64-17.31c1.62-5.75,3.33-11.48,5.22-17.17l.06.11Z",
    transform: "translate(-553.52 -77.98)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M750.63,455.37,739.3,451.9,758.9,370a.09.09,0,0,1,.12-.08l21.55,5.2a.11.11,0,0,1,.07.14Q765.64,415.33,750.63,455.37Z",
    transform: "translate(-553.52 -77.98)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M750.67,455.45c-1-.27-2-.59-2.9-.88l-2.82-.88L739.28,452l-.06,0,0-.06c1.84-7.8,3.75-15.58,5.38-23.42s3-15.76,4.49-23.64l1.14-5.91,1.24-5.88c.42-2,.85-3.91,1.31-5.86s.9-3.91,1.48-5.83c1.15-3.84,2.8-7.56,4.16-11.36l0-.1a.56.56,0,0,1,.3-.34.59.59,0,0,1,.23-.05.35.35,0,0,1,.14,0l.09,0,.36.12.71.25,1.44.45c1,.29,1.92.56,2.89.81l5.84,1.44,5.83,1.44,2.92.7.73.17.37.09.18,0s.16,0,.18.12a14.29,14.29,0,0,1-.49,1.44l-2.08,5.64a22.71,22.71,0,0,0-1.59,5.9c-.25,2.11-.24,4.4-.44,6.63a21.11,21.11,0,0,1-1.44,6.22c-1.49,3.85-3,7.69-4.54,11.49C763.93,427.68,757.27,442.39,750.67,455.45Zm-.08-.16c4.63-17,9.22-32.24,14.29-47.07,1.26-3.71,2.57-7.37,3.9-11a16.5,16.5,0,0,1,2.77-5c1.21-1.52,2.62-3,3.77-4.62a20.74,20.74,0,0,0,2.64-5.36l2.13-5.61c.17-.45.39-1,.51-1.38,0-.06-.2-.06-.3-.1l-.36-.09-.73-.18-2.92-.72-5.85-1.37-5.85-1.38c-1-.22-2-.43-2.94-.61l-1.49-.24-.75-.11-.37-.06h0a.32.32,0,0,0,.14,0,.32.32,0,0,0,.18-.2s0,.06,0,.08c-.51,4-.71,8.07-1.43,12-.35,2-.84,3.92-1.32,5.87s-1,3.88-1.48,5.82l-1.56,5.8-1.65,5.79c-2.25,7.7-4.62,15.37-6.7,23.11s-3.92,15.53-5.8,23.32l0-.08,5.66,1.75,2.84.85C748.77,454.72,749.72,455,750.59,455.29Z",
    transform: "translate(-553.52 -77.98)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 945.4,
    y: 266.36,
    width: 4.9,
    height: 18.9,
    rx: 1.98,
    transform: "translate(1189.48 782.83) rotate(-159.88)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-13",
    cx: 185.76,
    cy: 393.16,
    rx: 9.04,
    ry: 9.4
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M818.84,195.16c4-5.52,13.54-9.22,23.83-9.39a42.32,42.32,0,0,1,21.69,5.31,17.91,17.91,0,0,1,3.94,3.69c7.38,8.82,9.34,25,2.53,35.32a22.64,22.64,0,0,1-10,8.25c-13.58,6.08-30.82-1.41-39-14.43a36.5,36.5,0,0,1-4.54-11Z",
    transform: "translate(-553.52 -77.98)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M845.36,303.24",
    transform: "translate(-553.52 -77.98)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M779.33,259.41",
    transform: "translate(-553.52 -77.98)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M762.27,242.79",
    transform: "translate(-553.52 -77.98)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M877.74,344.19",
    transform: "translate(-553.52 -77.98)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M818.07,278.11",
    transform: "translate(-553.52 -77.98)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M787.47,258.46",
    transform: "translate(-553.52 -77.98)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M831.69,282.58c1.3,6.05,4.42,8,5.18,8.48,5.55,3.23,15.37-.22,21.83-10.44a29.46,29.46,0,0,1-2.1-3.71,26.46,26.46,0,0,1-2.38-6.93,48.33,48.33,0,0,1-.58-6.45c-.09-1.85-.12-3.72-.14-4.86,0-1.41,0-2.6,0-3.46l-16,.11c.07.85.16,2,.23,3.46.1,1.72.18,3.35.15,5.09a35,35,0,0,1-.61,6c0,.09,0,.2-.06.33a31.41,31.41,0,0,1-2.88,7.58C833.68,279.08,832.81,280.72,831.69,282.58Z",
    transform: "translate(-553.52 -77.98)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M822.36,223.91c.22,7.13.43,12.18,2.87,17.79,2.11,4.85,4.83,7.67,7.47,10.41,4.6,4.75,7.76,8,12.06,8s7.09-3.1,12-8.33c3.17-3.36,6.63-7,8.91-13.4,1.8-5,2-9.21,2.2-14.51.38-8.76.6-14-1.49-19.11-4-9.65-14.07-13.37-21.3-13.38s-17.35,3.76-21.36,13.41C821.91,209.25,822.06,214.14,822.36,223.91Z",
    transform: "translate(-553.52 -77.98)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M831.81,187a37.51,37.51,0,0,1,18.47-1.51c13.92,2.49,29.7,14.11,29,27.36-.28,5.06-3,11.08-8,13.85-9.59,5.31-23.46-3.59-31.32-8.64-6.29-4-4.85-4.75-13.32-10.44-3.74-2.51-6.57-4.09-7.21-7.18s1.4-6.25,2.87-8Z",
    transform: "translate(-553.52 -77.98)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M812.81,387",
    transform: "translate(-553.52 -77.98)"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-29",
    cx: 299.79,
    cy: 151.78,
    r: 7.15
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-29",
    cx: 277.28,
    cy: 150.35,
    r: 7.15
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-29",
    x1: 284.93,
    y1: 150.35,
    x2: 292.64,
    y2: 150.35
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-30",
    cx: 66.49,
    cy: 66.49,
    r: 53.49
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 110.74,
    y: 46.62,
    width: 120.68,
    height: 120.68,
    rx: 60.34
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 128.31,
    y: 98.08,
    width: 84.92,
    height: 17.81,
    rx: 8.91
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-33",
    cx: 66.15,
    cy: 52.92,
    rx: 25.04,
    ry: 28.95
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 33.98,
    y: 47.54,
    width: 65.02,
    height: 56.66,
    rx: 12.75
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-17",
    cx: 66.15,
    cy: 69.99,
    rx: 6.49,
    ry: 10.08
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 62.87,
    y: 76.46,
    width: 6.49,
    height: 15.36,
    rx: 2.48
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 957.92,
    y: 633.28,
    width: 102.71,
    height: 7.46,
    transform: "translate(1465.03 1196.04) rotate(180)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M984,589.36q2.47-6.63,5-13.26l41,.06,5.76,13.31Z",
    transform: "translate(-553.52 -77.98)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M979,602.71l62.25-.35q6.57,15.21,13.15,30.4H967.78Q973.41,617.73,979,602.71Z",
    transform: "translate(-553.52 -77.98)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M994.79,564.24q4.53-12.13,9.07-24.29h10.52q5.25,12.15,10.51,24.29Z",
    transform: "translate(-553.52 -77.98)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg403Error);
export default __webpack_public_path__ + "static/media/403Error.1de327e43fa21c4439cb9344cc566509.svg";
export { ForwardRef as ReactComponent };